"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopRecurrenceWorkScheduleSlotApiResponseSchema = void 0;
const zod_1 = require("zod");
const rrule_1 = require("../agenda-slots/rrule");
const api_1 = require("../global/api");
const stopRecurrenceWorkScheduleSlotItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('work-schedule-slots'),
    attributes: zod_1.z.object({
        rrule: rrule_1.rruleSchema,
    }),
});
exports.stopRecurrenceWorkScheduleSlotApiResponseSchema = zod_1.z.object({
    data: zod_1.z.array(stopRecurrenceWorkScheduleSlotItemApiResponseSchema),
});
